import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  SCHEDULE_REPORT_GET_JOB_LIST: createSagaAction('SCHEDULE_REPORT_GET_JOB_LIST'),
  SCHEDULE_REPORT_GET_FULL_REPORT: createSagaAction('SCHEDULE_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  scheduleReportGetJobList: ({ filters }) => ({
    type: constants.SCHEDULE_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  scheduleReportGetFullReport: ({ filters }) => ({
    type: constants.SCHEDULE_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.SCHEDULE_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.SCHEDULE_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.SCHEDULE_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.SCHEDULE_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/general/scheduleReportActions.js